import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingCounter = 0;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$: Observable<boolean> = this.loadingSubject.asObservable();
  private hideTimer: any;

  constructor() {}

  show(): void {
    this.loadingCounter++;
    console.log('LoadingService.show() called. Counter:', this.loadingCounter, 'Loading:', true);
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
    this.loadingSubject.next(true);
  }

  hide(): void {
    this.loadingCounter--;
    console.log('LoadingService.hide() called. Counter:', this.loadingCounter);
    if (this.loadingCounter <= 0) {
      this.loadingCounter = 0;
      // Add a small delay to ensure loader is visible for at least 300ms
      this.hideTimer = setTimeout(() => {
        console.log('LoadingService hiding loader');
        this.loadingSubject.next(false);
      }, 300);
    }
  }

  isLoading(): Observable<boolean> {
    return this.loading$;
  }
}
